(() => {
  const studio = document.querySelector('[data-flyer-studio]');
  if (!studio) return;

  const form = studio.querySelector('[data-flyer-form]');
  const flyer = studio.querySelector('[data-flyer-preview]');
  const fields = {
    creator: studio.querySelector('[data-field-creator]'),
    headline: studio.querySelector('[data-field-headline]'),
    subhead: studio.querySelector('[data-field-subhead]'),
    link: studio.querySelector('[data-field-link]'),
    code: studio.querySelector('[data-field-code]'),
    collection: studio.querySelector('[data-field-collection]'),
    productSearch: studio.querySelector('[data-field-product-search]'),
    product: studio.querySelector('[data-field-product]'),
    theme: studio.querySelector('[data-field-theme]'),
    backgroundColor: studio.querySelector('[data-field-background-color]'),
    headlineColor: studio.querySelector('[data-field-headline-color]'),
    descriptionColor: studio.querySelector('[data-field-description-color]'),
    accentColor: studio.querySelector('[data-field-accent-color]'),
    permission: studio.querySelector('[data-field-permission]')
  };
  const output = {
    creator: studio.querySelector('[data-output-creator]'),
    headline: studio.querySelector('[data-output-headline]'),
    subhead: studio.querySelector('[data-output-subhead]'),
    link: studio.querySelector('[data-output-link]'),
    code: studio.querySelector('[data-output-code]'),
    productName: studio.querySelector('[data-output-product-name]'),
    productPrice: studio.querySelector('[data-output-product-price]'),
    productImage: studio.querySelector('[data-output-product-image]'),
    productPlaceholder: studio.querySelector('[data-output-product-placeholder]'),
    qr: studio.querySelector('[data-output-qr]'),
    qrPlaceholder: studio.querySelector('[data-output-qr-placeholder]')
  };
  const printButton = studio.querySelector('[data-print-flyer]');
  const resetButton = studio.querySelector('[data-reset-flyer]');
  const status = studio.querySelector('[data-flyer-status]');
  const allowedDomain = (studio.dataset.allowedDomain || 'precision3d.shop').replace(/^www\./, '').toLowerCase();
  const productCatalog = Array.from(fields.product.querySelectorAll('option[data-collection]')).map((option) => ({
    value: option.value,
    collection: option.dataset.collection,
    search: option.dataset.search || option.textContent.toLowerCase(),
    title: option.dataset.title,
    price: option.dataset.price,
    image: option.dataset.image,
    label: option.textContent.trim()
  }));
  let qrReady = false;
  let qrError = false;
  let linkValid = false;
  const themeColors = {
    precision: { background: '#111116', headline: '#ffffff', description: '#d8d8df', accent: '#e3272d' },
    ocean: { background: '#08283a', headline: '#ffffff', description: '#d5edf5', accent: '#166c9d' },
    purple: { background: '#211637', headline: '#ffffff', description: '#eadff5', accent: '#633aa8' },
    bright: { background: '#30170d', headline: '#ffffff', description: '#ffe3d2', accent: '#ff5b22' }
  };

  const setText = (node, value, fallback) => {
    if (node) node.textContent = value.trim() || fallback;
  };

  const validateAffiliateLink = (value) => {
    try {
      const url = new URL(value);
      const hostname = url.hostname.replace(/^www\./, '').toLowerCase();
      return (url.protocol === 'https:' || url.protocol === 'http:') && hostname === allowedDomain;
    } catch (_error) {
      return false;
    }
  };

  const updatePrintState = () => {
    const permitted = Boolean(fields.permission && fields.permission.checked);
    printButton.disabled = !(permitted && linkValid && qrReady);
    if (!fields.link.value.trim()) {
      status.textContent = 'Add your Precision 3D affiliate link to create the QR code.';
    } else if (!linkValid) {
      status.textContent = `Use the full affiliate link from ${allowedDomain}.`;
    } else if (qrError) {
      status.textContent = 'The QR code could not load. Check your connection and try the link again.';
    } else if (!qrReady) {
      status.textContent = 'Creating your QR code…';
    } else if (!permitted) {
      status.textContent = 'Confirm the school-distribution rule before printing.';
    } else {
      status.textContent = 'Your flyer is ready to print or save as a PDF.';
    }
  };

  const updateProduct = () => {
    const option = fields.product.options[fields.product.selectedIndex];
    const title = option && option.dataset.title ? option.dataset.title : 'Handcrafted 3D prints';
    const price = option && option.dataset.price ? option.dataset.price : '';
    const image = option && option.dataset.image ? option.dataset.image : '';
    setText(output.productName, title, 'Handcrafted 3D prints');
    setText(output.productPrice, price, '');
    output.productPrice.hidden = !price;
    if (image) {
      output.productImage.src = image;
      output.productImage.alt = title;
      output.productImage.hidden = false;
      output.productPlaceholder.hidden = true;
    } else {
      output.productImage.removeAttribute('src');
      output.productImage.hidden = true;
      output.productPlaceholder.hidden = false;
    }
  };

  const makeProductOption = (product) => {
    const option = document.createElement('option');
    option.value = product.value;
    option.textContent = product.label;
    option.dataset.title = product.title;
    option.dataset.price = product.price;
    option.dataset.image = product.image;
    return option;
  };

  const updateProductOptions = () => {
    const collection = fields.collection.value;
    const query = fields.productSearch.value.trim().toLowerCase();
    const previousValue = fields.product.value;
    const matches = productCatalog.filter((product) => (
      product.collection === collection && (!query || product.search.includes(query))
    ));

    fields.product.replaceChildren();
    const prompt = document.createElement('option');
    prompt.value = '';
    prompt.dataset.title = 'Handcrafted 3D prints';
    prompt.dataset.price = '';
    prompt.dataset.image = '';

    if (!collection) {
      prompt.textContent = 'Choose a collection first';
    } else if (!matches.length) {
      prompt.textContent = 'No matching products found';
    } else {
      prompt.textContent = 'Choose a specific item';
    }
    fields.product.appendChild(prompt);

    matches.forEach((product) => fields.product.appendChild(makeProductOption(product)));
    if (matches.some((product) => product.value === previousValue)) {
      fields.product.value = previousValue;
    }

    fields.productSearch.disabled = !collection;
    fields.product.disabled = !collection || !matches.length;
    updateProduct();
  };

  const applyCustomColors = () => {
    flyer.style.setProperty('--flyer-header-bg', fields.backgroundColor.value);
    flyer.style.setProperty('--flyer-headline', fields.headlineColor.value);
    flyer.style.setProperty('--flyer-subhead', fields.descriptionColor.value);
    flyer.style.setProperty('--flyer-accent', fields.accentColor.value);
  };

  const applyThemeColors = () => {
    const colors = themeColors[fields.theme.value] || themeColors.precision;
    fields.backgroundColor.value = colors.background;
    fields.headlineColor.value = colors.headline;
    fields.descriptionColor.value = colors.description;
    fields.accentColor.value = colors.accent;
    applyCustomColors();
  };

  const updateQr = () => {
    const value = fields.link.value.trim();
    linkValid = validateAffiliateLink(value);
    qrReady = false;
    qrError = false;
    output.qr.hidden = true;
    output.qrPlaceholder.hidden = false;
    setText(output.link, linkValid ? value.replace(/^https?:\/\//, '').replace(/\/$/, '') : 'precision3d.shop', 'precision3d.shop');
    if (linkValid) {
      output.qr.alt = 'QR code for creator affiliate link';
      output.qr.src = `https://quickchart.io/qr?text=${encodeURIComponent(value)}&size=600&margin=2&ecLevel=M&format=png`;
    } else {
      output.qr.removeAttribute('src');
    }
    updatePrintState();
  };

  const update = (event) => {
    if (!event || event.target === fields.creator) setText(output.creator, fields.creator.value, 'Precision 3D Student Creator');
    if (!event || event.target === fields.headline) setText(output.headline, fields.headline.value, 'Bring home something awesome.');
    if (!event || event.target === fields.subhead) setText(output.subhead, fields.subhead.value, 'Handcrafted 3D printed toys, fidgets, gifts, and collectibles.');
    if (!event || event.target === fields.code) {
      const code = fields.code.value.trim();
      output.code.textContent = code ? `Creator code: ${code}` : '';
      output.code.hidden = !code;
    }
    if (!event || event.target === fields.theme) {
      flyer.dataset.theme = fields.theme.value;
      if (event) applyThemeColors();
    }
    if (
      !event ||
      event.target === fields.backgroundColor ||
      event.target === fields.headlineColor ||
      event.target === fields.descriptionColor ||
      event.target === fields.accentColor
    ) applyCustomColors();
    if (!event || event.target === fields.collection || event.target === fields.productSearch) updateProductOptions();
    if (event && event.target === fields.product) updateProduct();
    if (!event || event.target === fields.link) updateQr();
    if (event && event.target === fields.permission) updatePrintState();
  };

  output.qr.addEventListener('load', () => {
    qrReady = true;
    qrError = false;
    output.qr.hidden = false;
    output.qrPlaceholder.hidden = true;
    updatePrintState();
  });
  output.qr.addEventListener('error', () => {
    qrReady = false;
    qrError = true;
    output.qr.hidden = true;
    output.qrPlaceholder.hidden = false;
    output.qrPlaceholder.textContent = 'QR code could not load. Check your connection and try again.';
    updatePrintState();
  });

  form.addEventListener('input', update);
  form.addEventListener('change', update);
  printButton.addEventListener('click', () => {
    updatePrintState();
    if (!printButton.disabled) window.print();
  });
  resetButton.addEventListener('click', () => {
    form.reset();
    output.qrPlaceholder.textContent = 'Your QR code will appear here.';
    applyThemeColors();
    update();
  });
  applyThemeColors();
  update();
})();
